<template>
    <div>
        <div class="section col-md-12">
            <div class="col-md-12">
                <div class="button-back" role="button" v-on:click="back()"><i class="fas fa-arrow-left"></i> Back</div>
            </div>
        </div>
        <br/>
        <div class="section col-md-12">
            <div class="flex-row">
                <div class="col-md-6 flex-cell">
                    <div class="flex-cell-child">
                        <div class="severity-circle">
                            <div v-if="currentAnswer.severity === null"
                                 class="circle-action circle-red"></div>
                            <div v-if="currentAnswer.severity == 0"
                                 class="circle-action circle-red"></div>
                            <div v-if="currentAnswer.severity == 1"
                                 class="circle-action circle-amber"></div>
                            <div v-if="currentAnswer.severity == 2"
                                 class="circle-action circle-green"></div>
                        </div>
                        <div class="severity-title">
                            {{ currentSeverity[currentAnswer.severity] }}
                        </div>
                        <br>
                        <div class="card-title card-title-300">
                            {{ currentAnswer.question }}
                            <div v-if="currentAnswer.info_link && currentAnswer.additional_info" style="line-height: 1;">
                                <a :href="currentAnswer.info_link" target="_blank" rel="noopener noreferer">
                                  <span class="glyphicon glyphicon-plus-sign" style="color: #EFC100; font-size: 19px; margin-right: 6px; margin-top: 5px;" aria-hidden="true"></span>
                                  {{currentAnswer.additional_info}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 flex-cell">
                    <div class="flex-cell-child">
                        <div class="target-remedy card-title-margin">Your answer:</div>
                        <div class="card-title">{{ currentAnswer.answer }}</div>
                        <button v-on:click="showModal()" class="answer-button">
                            <span class="update-answer">UPDATE ANSWER</span>
                        </button>
                    </div>
                </div>
            </div>
            <br>
            <template v-if="currentCheckpoints && currentCheckpoints.length > 0">
              <div class="flex-row">
                  <div class="col-md-6 flex-cell">
                      <div class="flex-cell-child">
                          <div class="target-remedy card-title-margin">Checkpoints:</div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="checkpoints">
                                  <template v-for="checkpoint in currentCheckpoints" :key="checkpoint.id">
                                      <question-checkpoint :checkpoint="checkpoint" @onUpdate="updateCheckpoint($event, checkpoint)"/>
                                  </template>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
              <br>
            </template>
            <div class="flex-row flex-row-one">
                <div class="col-md-12 flex-cell">
                    <div class="flex-cell-child">
                        <div class="row">
                            <div class="col-md-6" v-if="checkCorrectlyAnsweredValue(answer) || checkCorrectlyAnsweredStatus(currentAnswer)">
                              <span class="status-track status-marks-completed"><i class="far fa-check"></i> Correctly Answered</span>
                            </div>
                            <div class="col-md-6" v-else-if="checkNaAnsweredValue(currentAnswer)">
                              <span class="target-remedy">N/A</span>
                            </div>
                            <div class="col-md-6" v-else>
                              <div class="target-remedy">Target Remedy:</div>
                              <div class="target-remedy-date">
                                {{ foramtTargetRemedyDate(currentAnswer.target_remedy) }}
                                <form ref="form" method="post"
                                      :action="`/assessment/action-tracker/${currentAnswer.question_id}/ics`"
                                      style="display: inline-block; margin-left: 20px;">
                                  <input type="hidden" name="_token" :value="csrf">
                                  <input type="hidden" name="date_start" :value="currentAnswer.target_remedy">
                                  <input type="hidden" name="date_end" :value="currentAnswer.target_remedy">
                                  <input type="hidden" name="location" value="">
                                  <input type="hidden" name="description" :value="`${currentAnswer.answer}`">
                                  <input type="hidden" name="summary"
                                         :value="`Model Office - ${currentAnswer.question}`">
                                  <input type="hidden" name="url" :value="currentUrl">
                                  <span role="button" v-on:click="submit()"><i
                                      class="fas fa-calendar-alt"></i></span>
                                </form>
                              </div>
                              <div class="card-title-copy-2" v-bind:class="{['expiredDate'] : getExpiredTime()}">
                                {{ getTimeToEnd() }}
                              </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="status" class="col-sm-4 col-form-label target-remedy card-title-margin">Status:</label>
                                    <div class="col-sm-8">
                                        <select name="status" class="card-title background"
                                                v-on:change="setNewStatus($event)" id="status">
                                            <option value="">Select Status</option>
                                            <template v-for="status in statuses">
                                              <option
                                                  v-if="status !== 'Completed'"
                                                  :value="status"
                                                  v-bind:selected="status === currentAnswer.status">
                                                {{ status }}
                                              </option>
                                            </template>
                                            <option v-if="'Completed' === currentAnswer.status ||
                                              (currentUser && currentUser.account_role ==='auditor' && currentAnswer.no_score_completion) ||
                                              (currentAnswer.no_score_completion) ||
                                              (currentAnswer.user_id && checkpointsAnswered && currentAnswer.can_complete === 1 && currentAnswer.value >= 3)"
                                              value="Completed" v-bind:selected="'Completed' === currentAnswer.status">Completed</option>

                                            <option v-else-if="!currentAnswer.user_id" value="Completed" v-bind:selected="'Completed' === currentAnswer.status"
                                              disabled>Completed (select person responsible to enable this option)</option>

                                            <option v-else-if="!checkpointsAnswered" value="Completed" v-bind:selected="'Completed' === currentAnswer.status"
                                              disabled>Completed (tick all of the available checkpoints to enable this option)</option>

                                            <option v-else-if="currentAnswer.can_complete === 1" value="Completed" v-bind:selected="'Completed' === currentAnswer.status"
                                              disabled>Completed (update your answer to enable this option)</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12">
                                        <div v-show="savedStatus" style="color: green; text-align: right;">Status was successfully saved</div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                     <div class="col-sm-12 status-key">
                                        Status Key: <span class="status-marks-completed">Completed</span> - <span class="status-marks-on-track">On Track</span> - <span class="status-marks-delayed">Delayed</span> - <span class="status-marks-severely-delayed">Severely Delayed</span>
                                     </div>
                                </div>

                                <div class="form-group row">
                                    <label for="user" class="col-sm-4 col-form-label target-remedy card-title-margin">Person Responsible:</label>
                                    <div class="col-sm-8">
                                        <select name="users" class="card-title background"
                                                v-on:change="setNewUser($event)" id="user">
                                            <option value="">Select User</option>
                                            <option v-for="user in accountUsers.filter(u => !u.archived)" :value="user.id"
                                                    v-bind:selected="user.id === currentAnswer.user_id">
                                                {{ user.first_name }}
                                                {{ user.last_name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12" style="height: 12px;">
                                        <div v-show="savedUser" style="color: green; text-align: right;">Status was successfully saved</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          <template v-if="istrial">
            <br>
            <div class="flex-row">
              <div class="col-md-6 flex-cell">
                <div class="flex-cell-child">
                  <div class="target-remedy card-title-margin">Files:</div>
                  <document v-if="currentAnswer.answer_id" :title=false :withList="true" :answer=currentAnswer></document>
                  <div class="gradient-cover-trial" style="height: 250px">
                    <a href="/account/upgrade" target="_blank" style="height: 60px">
                      Upgrade to see more
                      <br>
                      <span>
                        If you want to access greater audit and benchmarking functionality including actions/steers/alerts/good practice to improve your training and competence, governance, risk, and compliance scores, plus gain integrations to relevant back-office tech you can upgrade to and choose a more comprehensive and relevant Model Office AI RegTech platform - to find out more click here
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <template v-if="documents">
            <br>
            <div class="flex-row">
              <div class="col-md-6 flex-cell">
                <div class="flex-cell-child">
                  <div class="target-remedy card-title-margin">Files:</div>
                  <document v-if="currentAnswer.answer_id" :title=false :withList="true" :answer=currentAnswer></document>
                </div>
              </div>
            </div>
            </template>
            <br>
            <div class="flex-row">
              <div class="col-md-6" style="padding: 0">
                <div class="flex-row" style="padding-bottom: 30px">
                  <div class="col-md-12 flex-cell">
                    <div class="flex-cell-child">
                      <div class="target-remedy card-title-margin">Notes:</div>
                      <div class="row row-comment" v-for="note in currentComments['notes']">
                        <div class="col-md-8 card-title card-title-300">
                          <div class="comment-content" v-html="note.comment"></div>
                        </div>
                        <div class="col-md-4 card-title card-title-300">
                          <span v-if="note.user.account_role==='auditor'" class="auditor-pill">Auditor<br /></span>{{note.user.first_name}} {{note.user.last_name}}<br />
                          {{ formatDate(note.created_at,note.updated_at) }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <a class="add-note" v-on:click.prevent.stop="showCommentModal($event, 'notes')">
                            <i class="fa fa-plus"></i>
                            Add Note
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex-row" style="padding-bottom: 30px" v-if="canconsumerdutyboardreport">
                  <div class="col-md-12 flex-cell">
                    <div class="flex-cell-child">
                      <div class="target-remedy card-title-margin">Complaints:</div>
                      <div class="row row-comment" v-for="complaint in currentComments['complaints']">
                        <div class="col-md-8 card-title card-title-300">
                          <div class="comment-content" v-html="complaint.comment"></div>
                          <div class="col-md-12" v-if="complaint.attached_file_name"><a :download="complaint.attached_file_name" :href="complaint.attached_file"><i class="fa fa-file-download"></i> {{complaint.attached_file_name}}</a></div>
                        </div>
                        <div class="col-md-4 card-title card-title-300">
                          <span v-if="complaint.user.account_role==='auditor'" class="auditor-pill">Auditor<br /></span>{{complaint.user.first_name}} {{complaint.user.last_name}}<br />
                          {{ formatDate(complaint.created_at,complaint.updated_at) }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <a class="add-note" v-on:click.prevent.stop="showCommentModal($event, 'complaints')">
                            <i class="fa fa-plus"></i>
                            Add Complaint
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex-row" style="padding-bottom: 30px" v-if="canconsumerdutyboardreport">
                  <div class="col-md-12 flex-cell">
                    <div class="flex-cell-child">
                      <div class="target-remedy card-title-margin">Good / Poor Outcomes:</div>
                      <div class="row row-comment" v-for="outcome in currentComments['outcomes']">
                        <div class="col-md-8 card-title card-title-300">
                          <div class="comment-content" v-html="outcome.comment"></div>
                          <div class="col-md-12" v-if="outcome.attached_file_name"><a :download="outcome.attached_file_name" :href="outcome.attached_file"><i class="fa fa-file-download"></i> {{outcome.attached_file_name}}</a></div>
                        </div>
                        <div class="col-md-4 card-title card-title-300">
                          <span v-if="outcome.user.account_role==='auditor'" class="auditor-pill">Auditor<br /></span>{{outcome.user.first_name}} {{outcome.user.last_name}}<br />
                          {{ formatDate(outcome.created_at,outcome.updated_at) }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <a class="add-note" v-on:click.prevent.stop="showCommentModal($event, 'outcomes_good')">
                            <i class="fa fa-plus"></i>
                            Add good outcomes
                          </a>
                        </div>
                        <div class="col-md-12">
                          <a class="add-note" v-on:click.prevent.stop="showCommentModal($event, 'outcomes_poor')">
                            <i class="fa fa-plus"></i>
                            Add poor outcome remedial strategy
                          </a>
                        </div>
                        <div class="col-md-12">
                          <a class="add-note" v-on:click.prevent.stop="showCommentModal($event, 'outcomes_change')">
                            <i class="fa fa-plus"></i>
                            Add change to firm policies & procedures / strategy
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                <div class="col-md-6 flex-cell">
                    <div class="flex-cell-child">
                        <div class="target-remedy card-title-margin">History:</div>
                        <template v-for="item in currentHistory">
                            <div class="row" v-if="item.user">
                                <div class="col-md-7 card-title card-title-300" v-if="item.option">
                                  <template v-if="item.change_log">
                                    Changed {{ item.change_log }}
                                    <template v-if="item.change_log === 'user'">to: {{getUserById(item.assign_user_id)}}</template>
                                    <template v-if="item.change_log === 'status'"> to: {{item.status}}</template>
                                    <template v-if="item.change_log === 'answer'">to: {{ item.option.text }}</template>
                                  </template>
                                  <template v-else>
                                    Answer: {{ item.option.text }}
                                  </template>
                                </div>
                                <div class="col-md-5 card-title card-title-300 text-right">
                                    {{ item.user ? item.user.first_name + ' ' + item.user.last_name : '---' }} | {{ formatDate(item.created_at, item.updated_at) }}
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
          </template>
        </div>

      <vue-final-modal
          modal-id="change-answer"
          class="modal--container modal-shadow"
          content-class="modal--content"
          :content-style="{height: 'auto'}"
          height="auto">
            <div class="answer-modal-content">
                <div class="card-title">Question:</div>
                <div class="card-title card-title-300">{{ currentAnswer.question }}</div>
                <br/>
                <div v-for="option in currentOptions" class="answer-row">
                    <div class="card-title card-title-300 answer-cell answer-cell-text"
                         v-bind:class="{['checked'] : option.id == currentAnswer.option_id}">
                        {{ option.text}}
                    </div>
                    <div class="answer-cell answer-cell-input">
                        <input :id="'id'+option.id" type="radio" name="new-answer" class="radio" :value="option.id"
                               v-bind:checked="option.id == currentAnswer.option_id"
                               v-on:change="setNewAnswer(option.id,option.value)">
                        <label :for="'id'+option.id" class="checkmark"></label>
                    </div>
                </div>
                <br/>
                <button class="answer-button" v-on:click="sendData('update-answer','change-answer')">
                    <span class="update-answer">UPDATE ANSWER</span>
                </button>
            </div>
        </vue-final-modal>

      <vue-final-modal
          modal-id="add-comment"
          class="modal--container modal-shadow"
          content-class="modal--content"
          :content-style="{height: 'auto'}"
          height="auto">
            <div class="answer-modal-content">

                <div class="card-title" v-if="currentCommentKey === 'notes'">Add Notes:</div>
                <div class="card-title" v-if="currentCommentKey === 'complaints' && canconsumerdutyboardreport">Add complaints:</div>
                <div class="card-title" v-if="currentCommentKey === 'outcomes_good' && canconsumerdutyboardreport">Add good outcome(s):</div>
                <div class="card-title" v-if="currentCommentKey === 'outcomes_poor' && canconsumerdutyboardreport">Add poor outcome(s) remedial strategy:</div>
                <div class="card-title" v-if="currentCommentKey === 'outcomes_change' && canconsumerdutyboardreport">Add change to firm policies & procedures / strategy:</div>

                <div class="card-subtitle">e.g. Follow on actions, delegated or handover, date resolved, date completed and reported <span v-if="currentCommentKey !== 'notes'"> and add relevant documents</span></div>
                <br/>

                <div v-if="editorView" class="trix-scroll-wrapper">
                  <TrixComponent v-if="editorView" :id="'text'" :text="this.currentComment" @dataFromTrix="getDataTextFromTrix"></TrixComponent>
                </div>
                <p class="notice-textarea-warning">{{ noticeLengthWarning }}</p>
                <br/>
                <input v-if="canconsumerdutyboardreport && currentCommentKey !== 'notes'" type="file" @change="onFileChange" accept=".pdf,.doc,.docx">
                <br>
                <button class="answer-button" v-on:click="sendData('add-comment','add-comment')">
                    <span class="update-answer" v-if="currentCommentKey === 'notes'">Add note</span>
                    <span class="update-answer" v-if="currentCommentKey === 'complaints' && canconsumerdutyboardreport">Add complaints</span>
                    <span class="update-answer" v-if="currentCommentKey === 'outcomes_good' && canconsumerdutyboardreport">Add good outcome</span>
                    <span class="update-answer" v-if="currentCommentKey === 'outcomes_poor' && canconsumerdutyboardreport">Add poor outcome remedial strategy</span>
                    <span class="update-answer" v-if="currentCommentKey === 'outcomes_change' && canconsumerdutyboardreport">Add change to firm policies & procedures / strategy</span>
                </button>
            </div>
        </vue-final-modal>
    </div>
</template>

<script>
import DocumentComponent from "./DocumentComponent";
import { VueFinalModal, ModalsContainer } from 'vue-final-modal'
import TrixComponent from "./tailwind_ui/components/TrixComponent.vue";

export default {
  props: [
    "answer",
    "checkpoints",
    "severity",
    "status",
    "options",
    "comments",
    "history",
    "user",
    "users",
    "account",
    "isnetwork",
    "documents",
    "shownaanswers",
    "istrial",
    "canconsumerdutyboardreport"
  ],
  components: {
    document: DocumentComponent,
    VueFinalModal,
    ModalsContainer,
    TrixComponent,
  },
  data() {
    return {
      currentAnswer: [],
      currentOptions: [],
      currentSeverity: [],
      currentStatus: [],
      currentOptionId: null,
      statuses: [],
      currentComments: [],
      currentComment: null,
      currentCommentKey: null,
      currentAttachedFile: null,
      noticeLengthWarning: null,
      currentHistory: [],
      endDate: null,
      savedStatus: false,
      csrf: null,
      currentUrl: null,
      accountUsers: [],
      currentUser: null,
      currentUserId: null,
      savedUser: false,
      currentCheckpoints: [],
      checkpointsAnswered: false,
      editorView: false,
    };
  },
  mounted() {
    this.currentUser = JSON.parse(this.user);
    this.accountUsers = JSON.parse(this.users);
    this.currentAnswer = JSON.parse(this.answer);
    this.currentAnswer = this.severityColor();

    this.currentSeverity = JSON.parse(this.severity);
    this.statuses = JSON.parse(this.status);
    this.currentOptions = JSON.parse(this.options);
    this.currentComments = JSON.parse(this.comments);
    this.currentHistory = JSON.parse(this.history);
    this.csrf = document.querySelector('meta[name="csrf-token"]').content;
    this.currentUrl = window.location.href;
    this.currentCheckpoints = this.updateCheckpointsAnwsered(
      JSON.parse(this.checkpoints)
    );
  },
  created() {
    this.$root.ActionTracker = this;
    this.editorView = true;
  },
  methods: {
    back: function () {
      window.history.back();
    },
    submit: function () {
      this.$refs.form.submit();
    },
    formatDate: function (created_at, updated_at) {
      let date = null;
      if (created_at || updated_at) {
        if (created_at) {
          date = created_at;
        } else {
          date = updated_at;
        }
        date = moment(date, "YYYY-MM-DD h:imm:ss").format("DD.MM.YYYY");
      }

      return date;
    },
    foramtTargetRemedyDate: function (date) {
        return moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
    },
    getTimeToEnd: function () {
      let txtWeeks = "";
      let txtDays = "";
      let txtExpired = "";
      let timeToEnd = "";

      let allDays = moment
        .duration(
          moment(this.currentAnswer.target_remedy, "YYYY-MM-DD").diff(moment())
        )
        .asDays();
      let weeks = parseInt(allDays / 7);
      let days = parseInt(allDays - weeks * 7);

      if (weeks < 0 || days < 0) {
        weeks = Math.abs(weeks);
        days = Math.abs(days);
        txtExpired = " ago";
      }

      if (weeks > 0) {
        txtWeeks = txtWeeks.concat(weeks.toString(), " weeks ");
      }
      if (days > 0) {
        txtDays = txtDays.concat(days.toString(), " days ");
      }

      return timeToEnd.concat(txtWeeks, txtDays, txtExpired);
    },
    getExpiredTime: function () {
      let end_date = moment(this.currentAnswer.target_remedy, "YYYY-MM-DD");
      let now_date = moment();

      return end_date < now_date;
    },
    showModal: function () {
      this.$vfm.open("change-answer");
    },
    showCommentModal: function (event, key) {
      this.currentCommentKey = key;
      event.preventDefault();
      this.$vfm.open("add-comment");
    },
    setNewAnswer: function (id) {
      this.currentOptionId = id;
    },
    setNewStatus: function (event) {
      this.currentStatus = event.target.value;
      this.sendData("update-status", null);
      setTimeout(() => this.showSavedStatus(), 1000);
      setTimeout(() => this.hideSavedStatus(), 3000);
    },
    setNewUser: function (event) {
      this.currentUserId = event.target.value;
      this.sendData("update-user", null);
      setTimeout(() => this.showSavedUser(), 1000);
      setTimeout(() => this.hideSavedUser(), 3000);
    },
    showSavedStatus: function () {
      this.savedStatus = true;
    },

    hideSavedStatus: function () {
      this.savedStatus = false;
    },
    showSavedUser: function () {
      this.savedUser = true;
    },

    hideSavedUser: function () {
      this.savedUser = false;
    },
    sendData: function (action, modalName) {
      self = this;
      this.$vfm.close(modalName);
      if(this.isnetwork)
        var url = `/member-firm/results/action-tracker/${JSON.parse(this.account).id}/${this.currentAnswer.question_id}`;
      else
        var url = "/assessment/action-tracker/" + this.currentAnswer.question_id;

      axios
        .post(url, {
          action: action,
          answer_id: this.currentAnswer.answer_id,
          option_id: this.currentOptionId,
          status: this.currentStatus,
          comment: this.currentComment,
          comment_type: this.currentCommentKey,
          parent_section: this.currentAnswer.parent_key,
          child_section: this.currentAnswer.child_key,
          user_id: this.currentUserId,
          attached_file: this.currentAttachedFile,
        }, {headers: {'Content-Type': 'multipart/form-data'}})
        .then(function (response) {
          self.currentAnswer = response.data.answer;
          self.currentAnswer = self.severityColor();
          self.currentComments = response.data.comments;
          self.currentHistory = response.data.history;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateCheckpoint: function (answered, checkpoint) {
      let checkpoints = [...this.currentCheckpoints];
      let checkpointsAnswersCount = 0;
      checkpoints.forEach((item) => {
        if (item.id == checkpoint.id) {
          item.answered = answered;
        }
        if (item.answered) {
          checkpointsAnswersCount += 1;
        }
      });

      if (checkpointsAnswersCount >= checkpoints.length) {
        this.checkpointsAnswered = true;
      }else{
        this.checkpointsAnswered = false;
      }

      if(this.isnetwork)
        var url = `/member-firm/results/action-tracker/${JSON.parse(this.account).id}/${this.currentAnswer.question_id}`;
      else
        var url = "/assessment/action-tracker/" + this.currentAnswer.question_id;

      axios
        .post(url, {
          action: "update-checkpoint",
          answered: answered,
          checkpoint_id: checkpoint.id,
        })
        .then((response) => {
          this.currentCheckpoints = this.updateCheckpointsAnwsered(
            response.data.checkpoints
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateCheckpointsAnwsered: function (checkpoints) {
      if (checkpoints && checkpoints.length > 0) {
        let checkpointsAnswersCount = 0;
        checkpoints.forEach((checkpoint) => {
          if (checkpoint.answers && checkpoint.answers.length > 0) {
            checkpointsAnswersCount += 1;
            checkpoint.answered = true;
          } else {
            checkpoint.answered = false;
          }
        });
        if (checkpointsAnswersCount >= checkpoints.length) {
          this.checkpointsAnswered = true;
        }
      } else {
        this.checkpointsAnswered = true;
      }
      return checkpoints;
    },
    severityColor: function () {
      if (this.currentAnswer.value < 3) {
        this.currentAnswer.color = 0;
      }
      if (this.currentAnswer.value < 3 && this.currentAnswer.severity === 0) {
        this.currentAnswer.color = 0;
      }
      if (this.currentAnswer.value < 3 && this.currentAnswer.severity === 1) {
        this.currentAnswer.color = 1;
      }
      if (this.currentAnswer.value < 3 && this.currentAnswer.severity === 2) {
        this.currentAnswer.color = 2;
      }
      if (this.currentAnswer.value >= 3) {
        this.currentAnswer.color = 3;
      }
      return this.currentAnswer;
    },
    onFileChange: function (event) {
      const files = event.target.files;
      if (files.length > 0) {
        const file = files[0];
        this.currentAttachedFile = file;
        console.log('Selected file:', file);
      }
    },
    getDataTextFromTrix(data) {
      this.currentComment = data;
    },
    getUserById(id) {
      const user = this.accountUsers.find(user => user.id === id);
      return user ? user.name : 'Unknown User';
    },
    checkCorrectlyAnsweredStatus(answer){
      return answer.initially_correct ?? false;
    },
    checkCorrectlyAnsweredValue(answer){
      return answer.correctly_answered ?? false;
    },
    checkNaAnsweredValue(answer){
      return !this.shownaanswers && answer.answer == 'N/A';
    } ,
  },
};
</script>
<style>
.trix-button--icon-bold,
.trix-button--icon-italic,
.trix-button--icon-strike,
.trix-button--icon-heading-1,
.trix-button--icon-quote,
.trix-button--icon-code,
.trix-button--icon-bullet-list,
.trix-button--icon-number-list,
.trix-button--icon-decrease-nesting-level,
.trix-button--icon-increase-nesting-level,
.trix-button-group-spacer
{
  display: none;
}
.trix-button-row .trix-button-group--block-tools {
  border: none;
}
.trix-scroll-wrapper trix-editor {
  max-height: 300px;
  overflow-y: auto;
}
.comment-content {
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
</style>
